<!--
 * @Author: wsx
 * @Date: 2022-01-12 14:57:29
 * @LastEditTime: 2022-03-05 10:53:43
 * @LastEditors: Please set LastEditors
 * @Description: 新增/编辑用户表单
-->
<template>
  <el-dialog
    v-model="formVisible"
    :title="status == 1 ? '添加' : '编辑'"
    width="40%"
  >
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      :disabled="isDisabled"
      label-width="120px"
      class="menuForm"
    >
      <el-form-item label="节点类型">
        <el-checkbox v-model="nodeType" border>根节点</el-checkbox>
      </el-form-item>
      <el-form-item label="上级菜单" v-if="!nodeType">
        <h-select
          v-model="ruleForm.parentId"
          :data="dataSource"
          type="tree"
          :options="{ label: 'name', id: 'menuId', children: 'children' }"
        ></h-select>
      </el-form-item>
      <el-form-item label="菜单名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          placeholder="请输入菜单名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单路由" v-if="ruleForm.type !== '0'">
        <el-input
          v-model="ruleForm.url"
          placeholder="请输入菜单路由"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单类型" prop="type">
        <el-radio-group v-model="ruleForm.type">
          <el-radio
            v-for="item in menuType"
            :key="item.code"
            :label="item.code"
            >{{ item.value }}</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item label="菜单图标">
        <el-popover
          ref="popoverRef"
          width="400px"
          trigger="click"
          placement="bottom-start"
        >
          <template #reference>
            <el-input
              v-model="ruleForm.icon"
              readonly
              placeholder="请选择图标"
            />
          </template>
          <div class="h-iconMenu-list">
            <template v-for="item in iconList" :key="item.icon_id">
              <div class="h-iconMenu-icon" @click="currentChange(item)">
                <h-icon
                  :icon="'icon-' + item.font_class"
                  fontSize="20"
                ></h-icon>
              </div>
            </template>
          </div>
        </el-popover>
      </el-form-item>
    </el-form>
    <template #footer>
      <template v-if="!isDisabled">
        <h-button type="primary" @click="submitForm(ruleFormRef)"
          >保存</h-button
        >
        <h-button @click="formVisible = false">取消</h-button>
      </template>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  computed,
  toRefs,
  watch,
  watchEffect,
  ref
} from "vue";
import util from "@util/js";
import iconfont from "@/assets/style/iconfont/iconfont.json";
import { getDict } from "@/api/constant";
import { ElMessage } from "element-plus";
import _ from "lodash";
import { getRoleSelect } from "@/api/system/role";
import { getMenuList, addMenu, addUpdateMenu } from "@/api/system/menu";
import HIcon from "../../../components/global/HIcon.vue";
export default defineComponent({
  name: "menuForm",
  components: { HIcon },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: Number,
      default: 1 // 1 添加；2 编辑；3 只读
    }
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    const state = reactive({
      formVisible: false,
      ruleForm: {
        menuId: "",
        parentId: "",
        name: "",
        parentName: "",
        url: "",
        perms: "",
        type: "0", // 0：目录 1：菜单 2：按钮
        icon: ""
      },
      typeq: 0,
      currentNode: {},
      nodeType: false,
      ruleFormBack: {},
      iconList: iconfont.glyphs,
      menuType: {},
      dataSource: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择菜单类型",
            trigger: "blur"
          }
        ]
      },
      options: [],
      urlVisable: true
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);

    // 获取角色列表
    const getRoleSelectAsync = async () => {
      const res = await getRoleSelect();
      state.options = res.list;
    };
    getRoleSelectAsync();

    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenuList();
      const list = result.menuList.filter(item => item.type !== 2);
      const options = { pid: "parentId", id: "menuId", rootPid: 0 };
      const treeData = util.arrayToTree(list, options);
      state.dataSource = treeData;
      return treeData;
    };
    queryOrganTreAsync();
    // 监听弹框显示因此
    const setDialogState = async v => {
      if (v) {
        state.nodeType = false;
      } else {
        await queryOrganTreAsync();
        state.ruleForm = _.cloneDeep(state.ruleFormBack);
        ruleFormRef.value && resetForm(ruleFormRef.value);
      }
      state.formVisible = v;
      const types = [2, 3];
      if (v && types.includes(props.status)) {
        initForm();
      }
      if (props.status === 1) {
        state.ruleForm.parentId = props.form.parentId;
      } else if (props.status === 2) {
        state.ruleForm.type = state.ruleForm.type + "";
        state.nodeType = state.ruleForm.parentId === 0;
      }
    };
    watch(
      () => props.modelValue,
      v => {
        setDialogState(v);
      },
      { immediate: true }
    );

    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });

    watchEffect(() => {
      if (state.nodeType) {
        state.ruleForm.parentId = 0;
      }
    });
    watch(
      () => state.ruleForm.type,
      v => {
        if (v === "0") {
          state.urlVisable = false;
        } else {
          state.urlVisable = true;
        }
      }
    );
    // 禁用
    const isDisabled = computed(() => {
      return props.status === 3;
    });
    const refData = toRefs(state);
    // 初始化表单
    const initForm = () => {
      const form = { ...state.ruleForm, ...props.form };
      state.ruleForm = _.cloneDeep(form);
    };
    // 获取菜单类型
    const queryMenuType = async () => {
      const res = await getDict("menu_type");
      state.menuType = res.dict;
    };
    queryMenuType();
    // 保存表单数据
    const submitForm = formEl => {
      if (!formEl) return;
      formEl.validate(async valid => {
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          form.deptId = props.form.parentId;
          util.formatForm(form);
          let res;
          if (props.status === 1) {
            res = await addMenu(form);
          } else if (props.status === 2) {
            res = await addUpdateMenu(form);
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            context.emit("submit");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    // 重置表单
    const resetForm = formEl => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const currentChange = item => {
      state.ruleForm.icon = "icon-" + item.font_class;
    };
    return {
      ...refData,
      submitForm,
      isDisabled,
      resetForm,
      ruleFormRef,
      currentChange
    };
  }
});
</script>
<style lang="scss" scoped>
.menuForm {
}
</style>
<style lang="scss">
.h-iconMenu-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 40px);
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  justify-content: space-around;
  .h-iconMenu-icon {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--el-border-color-base);
    border-radius: 3px;
    cursor: pointer;
    &.selected,
    &:hover {
      background-color: var(--el-color-primary);
      color: var(--el-color-white);
    }
  }
}
</style>
